import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  programVideos: [],
  success: false,
  error: null,
};

const programVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_PROGRAM_VIDEO_REQUEST:
    case actionTypes.UPDATE_PROGRAM_VIDEO_REQUEST:
    case actionTypes.DELETE_PROGRAM_VIDEO_REQUEST:
    case actionTypes.READ_PROGRAM_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    // SAVE SUCCESS
    case actionTypes.SAVE_PROGRAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        programVideos: [...state.programVideos, action.payload],
      };

    // UPDATE SUCCESS
    case actionTypes.UPDATE_PROGRAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        programVideos: state.programVideos.map((item) =>
          item.programvideoObjId === action.payload.programvideoObjId
            ? action.payload
            : item
        ),
      };

    // DELETE SUCCESS
    case actionTypes.DELETE_PROGRAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        programVideos: state.programVideos.filter(
          (item) => item.programvideoObjId !== action.payload.programvideoObjId
        ),
      };

    // READ SUCCESS
    case actionTypes.READ_PROGRAM_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        programVideos: action.payload,
      };

    // FAILURE
    case actionTypes.SAVE_PROGRAM_VIDEO_FAILURE:
    case actionTypes.UPDATE_PROGRAM_VIDEO_FAILURE:
    case actionTypes.DELETE_PROGRAM_VIDEO_FAILURE:
    case actionTypes.READ_PROGRAM_VIDEO_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default programVideosReducer;
